import { makeStyles } from '@material-ui/core/styles'
import { useBreakpoints } from 'commons/useBreakpoints'
import themesConfig from 'app/fuse-configs/themesConfig'

let importBoxHeight = 231
let importBoxDefault = {
  position: 'relative',
  border: '2px dashed #a8a8a8',
  backgroundColor: '#f2f2f2',
  borderRadius: 5,
  marginTop: 17,
  height: importBoxHeight,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  color: '#a8a8a8',
  textAlign: 'center',
  fontWeight: 'bold',
  alignItems: 'center',
}

export default makeStyles((theme) => ({
  tableContent: {
    position: 'relative',
  },
  tableWithFilters: {
    '& .filter': {
      width: 120,
      '& .material-icons': {
        fontSize: '2.4rem !important',
      },
      '& .MuiInputBase-adornedEnd': {
        padding: '8px 0',
      },
      '& .MuiInputBase-inputAdornedEnd': {
        color: '#a8a8a8',
        fontSize: '12px !important',
      },
      '& .MuiFormHelperText-root': {
        fontSize: 10,
        marginTop: 4,
        color: '#a8a8a8',
      },
      '& .MuiInput-underline:before': {
        borderColor: '#a8a8a8',
      },
    },
  },
  exportTabBtn: {
    color: '#0073b1',
    '& span': {
      color: '#0073b1',
    },
  },
  tableContentEmpty: {
    padding: 50,
  },
  picture: {
    width: 36,
    height: 36,
    overflow: 'hidden',
    borderRadius: '50%',
  },
  groupDialogStyleOne: {
    '& .MuiPaper-root': {
      maxWidth: 422,
    },
  },
  groupDialogStyleThree: {
    '& .MuiPaper-root': {
      paddingBottom: 22,
    },
    '& .MuiPaper-root.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthXs.MuiDialog-paperFullWidth.MuiPaper-rounded':
      {
        height: '100%',
      },
  },
  groupDialogStylTwo: {
    '& .MuiPaper-root': {
      minWidth: 410,
    },
  },
  subscriberCreateDialog: {
    '& .MuiPaper-root': {
      width: 400,
    },
  },
  avatarBackground: {
    backgroundColor: '#064e75',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 38,
  },
  avatarContainer: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatarInputContainer: {
    borderRadius: '50%',
    overflow: 'hidden',
    position: 'relative',
    width: 96,
    height: 96,
  },
  changeBtn: {
    color: 'white',
    background: 'rgba(0,0,0,0.6)',
    paddingTop: 8,
    paddingBottom: 12,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    fontSize: 8,
  },
  subscriberName: {
    color: 'white',
    fontSize: 16,
    marginTop: 16,
    marginBottom: 16,
  },
  avatarInput: {
    display: 'none',
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 23,
  },
  inputOne: {
    marginTop: 33,
  },
  inputIcon: {
    marginRight: 16,
    color: '#064e75',
  },
  lineAndText: {
    '& span': {
      display: 'block',
      borderBottom: '2px solid #e5e5e5',
      height: 2,
    },
    '& p': {
      marginTop: 16,
      marginBottom: 24,
      color: '#404040',
      fontSize: 11,
      padding: '0 24px',
    },
  },
  inputSelectForm: {
    width: '100%',
    border: '1px solid #cbcbcb',
    borderRadius: 4,
  },
  inputSelect: {
    marginTop: '10px !important',
    '& .MuiInputBase-inputSelect.MuiSelect-outlined': {
      padding: '10px 12px',
    },
  },
  selectLabel: {
    background: 'white',
    padding: '0 4px',
  },
  fixedSizeBtn: {
    minWidth: 116,
  },
  fixedSizeBtnWaiting: {
    width: 165,
    paddingLeft: 0,
    paddingRight: 0,
    textAlign: 'center',
  },
  redBtnWaiting: {
    backgroundColor: '#f74872',
    borderColor: '#f74872',
  },
  backToAll: {
    color: theme.palette.secondary.main,
    display: 'inline-flex',
    alignItems: 'center',
  },
  backToAllText: {
    lineHeight: '1.4',
  },
  pageHeader: {
    display: 'flex',
    width: '100%',
    paddingLeft: '2.4rem',
    justifyContent: 'space-between',
  },
  pageInfos: {
    display: 'flex',
    alignItems: 'center',
  },
  toolbarSubscriberPage: {
    backgroundColor: '#fff',
    justifyContent: 'space-between',
  },
  introductionDiv: {
    marginTop: 24,
    fontSize: 16,
    color: '#0f3040',
  },
  importWrapp: {
    padding: '20px 32px 30px 32px',
  },
  importActionBtn: {
    color: '#0073b1',
    background: 'none !important',
    fontSize: 14,
    fontWeight: 'normal',
    textTransform: 'none',
    padding: 0,
    border: 0,
    '& i': {
      marginRight: 8,
    },
  },
  importLinkBtnItem: {
    fontSize: 16,
    color: '#0073b1',
  },
  importLinkBtnMoreImport: {
    marginLeft: 32,
  },
  importBoxDefault,
  importBoxLoading: {
    ...importBoxDefault,
    border: '0px dashed #a8a8a8',
  },
  importBox: {
    ...importBoxDefault,
    fontSize: 13,
    color: '#a8a8a8',
    cursor: 'pointer',
  },
  importDefaultBox: {
    ...importBoxDefault,
    marginTop: 11,
    fontSize: 14,
    color: '#a8a8a8',
    cursor: 'pointer',
    '& p': {
      marginBottom: 10,
    },
    '& .defaultUploadBox': {
      marginTop: 0,
    },
  },
  importedSuccessBox: {
    ...importBoxDefault,
    backgroundColor: '#f6fdf8',
    border: '2px dashed #e5e5e5',
    fontSize: 16,
    color: '#4fd975',
  },
  importedSuccessBoxTextWrapp: {
    textAlign: 'center',
    display: 'inline-block',
  },
  importedSuccessBoxText: {
    color: '#0073b1',
    fontSize: 14,
    fontWeight: 'normal',
    borderTop: '1px solid #e5e5e5',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 16,
    paddingTop: 16,
    cursor: 'pointer',
    width: 'fit-content',
  },
  importedSuccessBoxTextIcon: {
    marginRight: 8,
    fontSize: 16,
    marginTop: 1,
  },
  importSuccessBox: {
    ...importBoxDefault,
    border: '2px dashed #e5e5e5',
    backgroundColor: '#f3fcfd',
    fontSize: 16,
    color: '#0073b1',
  },
  importNotFullySuccessBox: {
    ...importBoxDefault,
    border: '2px dashed #e5e5e5',
    backgroundColor: '#f3fcfd',
    fontSize: 16,
    color: '#0073b1',
  },
  importedNotFullySuccessBox: {
    ...importBoxDefault,
    border: '2px dashed #e5e5e5',
    backgroundColor: '#f3fcfd',
    fontSize: 16,
    color: '#0073b1',
  },
  importFailBox: {
    ...importBoxDefault,
    border: '2px dashed #e5e5e5',
    backgroundColor: '#fff5f8',
    color: '#f74872',
  },
  importBoxIcon: {
    fontSize: 86,
  },
  importProcessText: {
    marginTop: 35,
    fontSize: 16,
    fontStyle: 'normal',
  },

  deleteIconCSV: {
    color: '#fff',
    backgroundColor: '#f74872',
    borderRadius: '3px',
    padding: '7px 6px 2px 6px',
    cursor: 'pointer',
  },
  csvPreviewWrapp: {
    padding: '14px 0 90px 0',
  },
  csvPreviewTitle: {
    color: '#0f3040',
    fontSize: 20,
    fontWeight: 'bold',
    marginLeft: 36,
  },
  deleteRow: {
    cursor: 'pointer',
  },
  csvPreviewLoadMore: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 16,
    color: '#0f3040',
    marginBottom: 30,
  },
  csvPreviewLoadMoreBtn: {
    color: '#0073b1',
    cursor: 'pointer',
  },
  mediumIcon: {
    fontSize: '3rem',
    cursor: 'pointer',
  },
  spaceRight: {
    marginRight: 16,
    marginTop: 5,
  },
  pageHeaderRightBar: {
    display: 'flex',
    flexDirection: 'initial',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '2.4rem',
  },
  deleteBtn: {
    backgroundColor: '#f74872',
    '&:hover': {
      backgroundColor: '#f74872',
      borderColor: '#f74872',
    },
    '&:focus': {},
  },
  groupActionBtns: {
    padding: '8px 30px',
  },
  deleteTabBtn: {
    color: '#f74872',
    '& span': {
      color: '#f74872',
    },
  },
  overflowVisible: {
    overflow: 'visible',
    '& .MuiDialog-paperScrollPaper': {
      overflow: 'visible',
    },
  },
  createBtn: {
    float: 'right',
    marginTop: 25,
    backgroundColor: '#0073b1',
    marginBottom: 25,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0073b1',
    },
  },
  avatarNotSet: {
    color: 'white',
    background: '#e5e5e5',
    fontSize: 50,
    height: 115,
    lineHeight: '100px',
  },
  tagsSelect: {
    padding: '18.5px 14px',
  },

  csvPreviewInfoBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 30px',
    marginTop: 30,
  },
  msgBox: {
    display: 'flex',
    fontSize: 16,
    color: '#0f3040',
    marginBottom: 14,
    '& svg': {
      marginRight: 15,
      fontSize: 36,
    },
  },
  msgBoxDesc: {
    marginTop: 6,
  },
  msgBoxSuccessIcon: {
    color: '#4fd975',
  },
  msgBoxFailIcon: {
    color: '#f74872',
  },
  actionBox: {
    '& button': {
      fontSize: 12,
      backgroundColor: '#0073b1',
      '& img': {
        marginTop: 5,
        marginRight: 12,
      },
    },
  },

  importSelectGroupWrapp: {
    marginTop: 30,
    paddingTop: 37,
    borderTop: '1px solid #e5e5e5',
  },
  importSelectGroup: {
    maxWidth: 355,
    '& .selectTagText': {
      fontSize: 16,
      color: '#a8a8a8',
    },
  },
  importSelectGroupTitle: {
    fontSize: 18,
    color: '#0f3040',
    marginBottom: 13,
  },
  importSelectGroupDesc: {
    fontSize: 12,
    color: '#a8a8a8',
    marginTop: 7,
  },
  importBtn: {
    backgroundColor: '#0073b1',
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    display: 'inline-block',
    padding: '11px 21px',
    marginTop: 8,
    borderRadius: 5,
  },
  importBtnImg: {
    color: '#0f3040',
    backgroundColor: '#fff',
    padding: '6px 6px 1px 6px',
    cursor: 'pointer',
    marginRight: 8,
  },
  importInfoBox: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    top: 17,
    right: 17,
  },
  importInfoFileName: {
    color: '#0f3040',
    fontSize: 16,
    marginRight: 17,
  },
  dialogSwitchCreate: {
    '& .MuiPaper-root': {
      maxWidth: 761,
      borderRadius: 16,
    },
  },
  addSubscribersTitle: {
    textAlign: 'center',
    padding: '32px 32px 16px 32px',
    color: themesConfig.default.colors.primary,
    [theme.breakpoints.down('md')]: {
      paddingTop: 32,
      paddingBottom: 42,
    },

    '& .close-button': {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      padding: 5,
      color: themesConfig.default.colors.primary,
    },
  },
  addSubscribersContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 32px 32px 32px',
    '& .cs-p': {
      textAlign: 'center',
      fontSize: 18,
      padding: '0 40px',
      color: themesConfig.default.colors['dove-gray'],
    },
  },
  addSubscribersActionContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24,
    marginTop: 40,

    '& .add-variant-box': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      gap: 42,
      maxWidth: 188,
    },

    '& .divider': {
      backgroundColor: themesConfig.default.colors['primary-350'],
    },

    [useBreakpoints(theme).lessThan.sm]: {
      flexDirection: 'column',
      gap: 10,
      marginTop: 20,

      '& .add-variant-box': {
        gap: 10,
      },

      '& .divider': {
        display: 'none',
      },
    },
  },

  addSubscribersActionBtn: {
    borderColor: themesConfig.default.colors.primary,
    color: themesConfig.default.colors.primary,
    textTransform: 'none',
    '&:hover': {
      borderColor: themesConfig.default.colors.primary,
    },
  },
  importSubscriberBtn: {
    [theme.breakpoints.down('md')]: {
      pointerEvents: 'none',
      borderColor: '#e5e5e5 !important',
      color: '#e5e5e5 !important',
    },
  },
  importSubscriberDisabledBtn: {
    pointerEvents: 'none',
    borderColor: '#e5e5e5 !important',
    color: '#e5e5e5 !important',
    backgroundColor: '#a2a8ad !important',
  },
  inProcessText: {
    fontSize: 16,
  },
  checkboxSelectAll: {
    color: '#064e75',
    '&.Mu i-checked': {
      color: '#064e75',
    },
  },
  emptyTextOne: {
    color: '#a8a8a8',
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 15,
  },
  createBtnSecond: {
    marginTop: 24,
    fontSize: 12,
    backgroundColor: '#0073b1',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0073b1',
    },
    '& span': {
      marginLeft: 8,
    },
  },
  emptyIconOne: {
    color: '#a8a8a8',
    '& i': {
      fontSize: 156,
    },
  },
  gridEmpty: {
    minHeight: '-webkit-fill-available',
  },
  downloadBtn: {
    marginTop: 24,
  },
  checkboxBlue: {
    '& svg': {
      fill: '#0073b1',
    },
  },
  closeButton: {
    position: 'absolute',
    right: 21,
    top: 25,
    color: '#404040',
  },
  dialogTitle: {
    color: '#404040',
    fontSize: 24,
  },
  dialogContent: {
    color: '#404040',
    fontSize: 18,
    lineHeight: '1.78',
  },
  groupDialogStyleFour: {
    '& .MuiPaper-root': {
      maxWidth: 580,
      padding: '18px 30px 25px 16px',
    },
  },
  gotItActionBtns: {
    backgroundColor: '#0073b1',
  },
  contentStyle: {
    overflow: 'inherit',
  },
  link: {
    color: `${theme.palette.secondary.main} !important`,
    textDecoration: 'none !important',
    '&:focus, &:hover, &:visited, &:link, &:active': {
      textDecoration: 'none !important',
    },
  },
  paidBlock: {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
  },
  autoApproveStyle: {
    '@media(max-width: 742px)': {
      paddingTop: 12,
    },
  },
  importSelectGroupFaild: {
    pointerEvents: 'none',
    opacity: '0.5',
  },
  dialogViewValidContent: {
    lineHeight: '22px',
    '& table': {
      width: '100%',
    },
    '& ul': {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },

  dialogViewValidContentTwo: {
    padding: '8px 0 8px 0',
    '& table': {
      width: '100%',
    },
  },
  dialogViewValidContentThree: {
    fontSize: 16,
  },
  dialogViewValidWrapp: {
    padding: '0 24px 0 24px',
  },
  dialogViewCSVTitle: {
    color: '#404040',
    fontSize: 24,
    fontWeight: 'bold',
  },
  dialogViewCSVSubTitle: {
    marginTop: 10,
    marginBottom: 21,
    color: '#404040',
    fontSize: 16,
  },
  dialogViewCSVLine: {
    border: '1px solid #e5e5e5',
  },
  dialogViewCSVTable: {
    fontSize: 14,
    color: '#404040',
    marginTop: 16,
    borderSpacing: 0,
    '& th': {
      fontWeight: 'normal',
      textAlign: 'left',
      padding: '3px 0 12px 0',
    },
    '& tbody tr': {
      fontWeight: 'normal',
      textAlign: 'left',
      backgroundColor: '#f9f9f9',
    },
    '& tbody td': {
      padding: '23px 0px',
    },
  },
  dialogViewCSVDownloadBtn: {
    color: '#0073b1',
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: 20,
    backgroundColor: 'transparent !important',
    padding: 0,
    marginTop: 30,
    '& i': {
      marginRight: 8,
    },
  },
  dialogViewCSVDownloadBtnWrapp: {
    display: 'flex',
    justifyContent: 'center',
  },
  dialogViewCSVActionPanel: {
    padding: '15px 32px 32px 8px',
  },
  colorOne: {
    color: '#f74872',
  },
  stepProgressWrap: {
    width: '100%',
    marginTop: 26,
    marginBottom: 16,
  },
  stepProgress: {
    width: '100%',
    height: 12,
    backgroundColor: '#f2f2f2',
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 9,
    backgroundImage: 'linear-gradient(89deg, #003a59 0%, #0073b1 100%)',
    backgroundSize: '0px',
    backgroundRepeat: 'no-repeat',
    '& > div': {
      width: 30,
      height: 30,
      backgroundColor: '#f2f2f2',
      borderRadius: '50%',
    },
    '& > div.active': {
      width: 40,
      height: 40,
      boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
      border: 'solid 5px #0073b1',
      backgroundColor: '#fff',
    },
  },
  stepProgress2: {
    backgroundSize: '50%',
    '& > div:nth-child(1)': {
      backgroundColor: '#003a59',
    },
  },
  stepProgress3: {
    backgroundSize: '100%',
    '& > div:nth-child(1)': {
      backgroundColor: '#003a59',
    },
    '& > div:nth-child(2)': {
      backgroundColor: '#005582',
    },
  },
  downloadErrorCSVFile: {
    marginTop: 19,
    fontSize: 14,
    color: '#0073b1',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '& i': {
      marginRight: 8,
    },
  },
  dialogViewValidItem: {
    display: 'flex',
    '& > div:first-child': {
      width: 135,
    },
  },
  importChooseBox: {
    display: 'flex',
    flexDirection: 'row',
  },
  importChooseOne: {
    flexGrow: 1,
    flexBasis: 0,
    marginRight: 12,
  },
  importChooseTwo: {
    flexGrow: 1,
    flexBasis: 0,
    marginLeft: 12,
  },
  importChooseBoxTitle: {
    display: 'flex',
    marginBottom: 24,
    color: '#404040',
    fontSize: 20,
    fontWeight: 'bold',
    alignItems: 'center',
    '& > svg': {
      fontSize: 40,
      marginRight: 8,
    },
  },
  importDefaultBoxText: {
    marginTop: 14,
    color: '#404040',
    fontSize: 14,
  },
  boxCSVDownloadBtn: {
    color: '#0073b1 !important',
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: 20,
    backgroundColor: 'transparent !important',
    padding: 0,
    marginTop: 67,
    textDecoration: 'none !important',
    '& i': {
      marginRight: 8,
      fontSize: 36,
    },
  },
  externalSourceBox: {
    borderRadius: 5,
    backgroundColor: '#f2f2f2',
    height: importBoxHeight,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 34,
  },
  msgBoxWarningIcon_2: {
    color: '#0073b1',
    fontSize: 80,
  },
  msgBoxFailingIcon_2: {
    color: '#f74872',
    fontSize: 80,
  },
  externalSourceBoxWarning: {
    flexDirection: 'column',
    backgroundColor: '#f3f8fd',
    color: '#0073b1',
    fontSize: 16,
    fontWeight: 'bold',
  },
  externalSourceBoxFailing: {
    flexDirection: 'column',
    backgroundColor: '#fff5f8',
    color: '#f74872',
    fontSize: 16,
    fontWeight: 'bold',
  },
  importSelectBox: {
    backgroundColor: '#fff',
  },
  optionItem: {
    backgroundColor: '#fff !important',
  },
  optionItemComingSoon: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    justifyContent: 'center',
    '&::before': {
      content: '""',
      width: 56,
      height: 1,
      position: 'absolute',
      backgroundColor: '#000',
      opacity: 0.5,
      left: 0,
      top: 10,
    },
    '&::after': {
      content: '""',
      width: 56,
      height: 1,
      position: 'absolute',
      backgroundColor: '#000',
      opacity: 0.5,
      right: 0,
      top: 10,
    },
  },
  importBackBtn: {
    fontSize: 16,
    color: '#0073b1',
    marginLeft: 8,
    fontWeight: 'normal',
    display: 'flex',
    alignItems: 'center',
    marginTop: 2,
    '& > svg': {
      fontSize: 14,
    },
  },
  exportDataSectionTitle: {
    padding: '20px 0px 0px 20px',
  },
  exportDataSectionContent: {
    padding: '15px 35px 0px 20px',
    '& .MuiButtonBase-root': {
      fontSize: 16,
      padding: 0,
    },
  },
  exportDataSectionActions: {
    padding: '0px 20px 20px 0px',
  },
  exportDataRadioItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
  },
  exportDataRadioType: {
    marginLeft: 8,
    fontSize: 14,
    color: '#404040',
  },
  exportDataRadioCount: {
    fontSize: 10,
    color: '#acacac',
    marginLeft: 3,
  },
  dialogExportData: {
    '& .MuiDialog-paper': {
      maxWidth: 400,
    },
  },
  exportDataByStatus: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  exportDataRadioTypeStatuses: {
    width: '88%',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 30,
    marginTop: 4,
    paddingTop: 10,
    borderTop: 'solid 1px rgb(112 112 112 / 22%)',
  },
  exportDataRadioTypeStatusItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
    '& svg': {
      fontSize: 16,
    },
    '& span.statusName': {
      marginLeft: 6,
      fontSize: 14,
      color: '#404040',
    },
  },
  postIcon: {
    width: '17px',
    margin: '5px',
  },
}))
